const SIZES_ENUMS = { SM: "sm", MD: "md", LG: "lg" };
export {
  SIZES_ENUMS
};
//# sourceMappingURL=constants.mjs.map
